/*
 * @Author: your name
 * @Date: 2020-11-17 16:08:14
 * @LastEditTime: 2021-06-29 14:20:23
 * @LastEditors: zhangcx33595
 * @Description: In User Settings Edit
 * @FilePath: \gtn2.0.V201902.58.004\openplat-web\src\gtn\store\modules\user.js
 */
import { login, logout, loginExit } from "../../api/login";
import Cookies from "js-cookie";
import hui from "h_ui/dist/h_ui.min.js";

const user = {
  state: {
    loginInfo:{},
    user: '',
    uPlusUser:{
      user_type_str:'',
      organizationId:'',
      isInner:''
    },
    //token: Cookies.get('Admin-Token'),
    token: window.sessionStorage.getItem("Access-Token"),
    optAuths: [],
    roles: [],
    hsid: "",
    message: "",
    asstReloginFlag: false
  },
  mutations: {
    LOGIN_SUCCESS: () => {
      //console.log('登录成功')
    },
    LOGOUT_USER: state => {
      state.user = "";
    },
    SET_USER: (state, user) => {
      state.loginInfo = user
      state.user = Object.assign({}, user.user);
      window.userForHeader = user.user // 挂在到window上面，给header组件中的埋点使用
      //console.log(state.user)
    },
    SET_UPLUS_USER: (state, uPlusUser) => {
      state.uPlusUser =  uPlusUser
      window.uPlusUserForHeader = uPlusUser // 挂在到window上面，给header组件中的埋点使用
    },
    //设置全局未读消息数
    SET_MESSAGE: (state, unReadMessage) => {
      state.message = unReadMessage;
    },
    SET_HSID: (state, hsid) => {
      state.hsid = hsid;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      //Cookies.set('Access-Token', token);
      window.sessionStorage.setItem("Access-Token", token);
      window.localStorage.setItem("Access-Token", token);
    },
    SET_OPT_AUTHS: (state, optAuths) => {
      state.optAuths = optAuths;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_asstReloginFlag: (state, data) => {
      state.asstReloginFlag = data;
    }
  },
  actions: {
    // 登录
    // 将token信息保存
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.checkcode)
          .then(response => {
            const data = response.data;
            if (data && data[window.LOCAL_CONFIG.SUCCESS_KEY] == "0") {
              window.sessionStorage.set("Admin-Token", data.sessionId);
              window.sessionStorage.setItem("userName", username);
              commit("SET_TOKEN", data.sessionId);
            }
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetInfo({ commit }, userInfo) {
      commit("SET_ROLES", ["admin"]);
    },
    // 登出
    // 将浏览器保存的token及权限清除
    Logout({ commit, state }) {
      // debugger
      Promise.all([logout(), loginExit()]).then(response => {
        if (response) {
          commit("SET_TOKEN", "");
          commit("SET_USER", {});
          gdp('clearUserId')
          window.sessionStorage.removeItem("Access-Token");
          window.sessionStorage.removeItem("lock");
          window.sessionStorage.removeItem("menus");
          window.sessionStorage.removeItem("menusType");
          window.sessionStorage.removeItem("userName");
          window.localStorage.removeItem("Access-Token");
          // 用户中心退出
          window.location.href =
            window.origin +
            "/iuc/logout" +
            "?service=" +
            encodeURIComponent(location.href);
          resolve(response[0]);
        } else {
          hui.hMessage.error("未退出成功");
        }
      });
    },
    ReLogin({ commit, state }) {
      commit("SET_TOKEN", "");
      Cookies.remove("Admin-Token");
      Cookies.remove("lock");
      window.sessionStorage.removeItem("menus");
      window.sessionStorage.removeItem("menusType");
      window.sessionStorage.removeItem("userName");
      location.reload();
    }
  }
};
export default user;



// WEBPACK FOOTER //
// ./src/gtn/store/modules/user.js